<template>
  <div class="row reverse-mobile justify-content-center">
    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <div class="d-flex" style="padding-bottom: 8px;">
          <h3>Scenarios</h3>
          <div class="ml-auto">
            <button
              class="btn btn-primary"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src="../assets/add.svg" class="mr-2" />
              Add Scenario
            </button>
            <div class="dropdown-menu">
              <router-link
                :to="{ name: 'scenarios-upload' }"
                class="dropdown-item"
              >
                Upload Scenario
              </router-link>
              <a v-if="!isOnNative" :href="webEditorUrl" class="dropdown-item">
                Create Scenario
              </a>
            </div>
          </div>
        </div>

        <div class="d-flex" style="padding-bottom: 16px;">
          <div v-if="scenariosCount > 0 && !isLoading" class="results-count">
            <b>{{ scenariosCount }}</b>
            Scenario{{ scenariosCount != 1 ? "s" : "" }} Found
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 d-flex align-items-center">
            <div class="input-group d-flex align-items-center">
              <input
                type="text"
                class="form-control"
                :placeholder="
                  selectedPatientAge == -1 &&
                  selectedPatientCondition == -1 &&
                  scenarioTags.length == 0
                    ? 'Search all scenarios'
                    : 'Search within selected scenario parameters'
                "
                aria-label="Search for"
                aria-describedby="basic-addon2"
                id="scenarioSeachTerm"
                @keyup.enter="updateSearchTerm"
              />
            </div>
          </div>
        </div>

        <div v-if="isLoading">
          <PleaseWait :bgColour="'#FFFFFF'"></PleaseWait>
        </div>

        <div v-if="scenariosCount <= 0 && !isLoading">
          <NoResults></NoResults>
        </div>

        <div
          v-if="scenariosCount > 0 && !isLoading"
          class="scenario-scroll-page"
        >
          <div class="placeholder">
            <Scenario
              v-cloak
              v-bind:key="scenario.id"
              v-for="scenario in scenarioObjects"
              :scenario="scenario"
              :currentlySelectedTags="scenarioTags"
            ></Scenario>
          </div>
          <div class="row d-flex justify-content-center">
            <div
              v-if="scenariosCount > 0"
              class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
            >
              <template>
                <select
                  class="dropdown-btn"
                  v-model="pageSize"
                  @change="pageSizeUpdated()"
                >
                  <option value="5">Show 5</option>
                  <option value="10">Show 10</option>
                  <option value="25">Show 25</option>
                  <option value="50">Show 50</option>
                </select>
                <paginate
                  v-model="page"
                  :page-count="pageCount"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                ></paginate>
              </template>
            </div>
          </div>
        </div>
      </CommunityCard>
    </div>

    <ScenarioTagFilter
      @tag-selection-updated="tagsUpdated"
      :availableTags="getScenarioTags"
      includePatientAgeSelector
      @age-selection-updated="selectPatientAge"
      includePatientConditionSelector
      @condition-selection-updated="selectPatientCondition"
      @filters-cleared="filtersCleared"
    />
  </div>
</template>

<script>
import Scenario from "../components/Scenario";
import ScenService from "../services/scenarios.service";
import Paginate from "../components/Paginate";
import NoResults from "../components/NoResults";
import PleaseWait from "../components/PleaseWait";
import CommunityCard from "../components/CommunityCard";
import ScenarioTagFilter from "../components/ScenarioTagFilter";

import ScenarioObject from "../objects/ScenarioObject";

export default {
  name: "Scenarios",
  deviceThumb: "",
  components: {
    Scenario,
    Paginate,
    PleaseWait,
    NoResults,
    CommunityCard,
    ScenarioTagFilter,
  },
  data: function() {
    return {
      isLoading: true,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      scenarios: [],
      scenarioTags: [],
      scenariosCount: 0,
      selectedPatientAge: -1,
      selectedPatientCondition: -1,
      searchTerm: -1,
      pageNum: 0,
      scenarioObjects: [],
      webEditorUrl: process.env.VUE_APP_CONTROL_DOMAIN,
      previousSelectedPageSize: 10,
      pageSize: 10,
    };
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    }
  },
  methods: {
    getScenarios(startAt) {
      this.isLoading = true;
      if (!this.searchTerm) {
        this.searchTerm = -1;
      }

      ScenService.scenarios(
        startAt,
        this.pageSize,
        this.selectedPatientAge,
        this.selectedPatientCondition,
        this.searchTerm,
        this.scenarioTags
      ).then((data) => {
        this.scenariosCount = data.total;
        this.scenarioObjects = [];
        for (let scenario in data.scenarios) {
          this.scenarioObjects.push(
            new ScenarioObject(data.scenarios[scenario])
          );
        }
        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.scenarioObjects = [];
      this.getScenarios(this.pageSize * pageNum);
    },

    getScenarioTags() {
      return ScenService.scenarioTags();
    },

    selectPatientAge(age) {
      this.isLoading = true;
      this.selectedPatientAge = age;
      this.getScenarios();
    },

    selectPatientCondition(condition) {
      this.isLoading = true;
      this.selectedPatientCondition = condition;
      this.getScenarios();
    },

    tagsUpdated(tags) {
      this.isLoading = true;
      this.scenarioTags = tags;
      this.getScenarios();
    },

    filtersCleared() {
      this.isLoading = true;
      this.selectedPatientAge = -1;
      this.selectedPatientCondition = -1;
      this.scenarioTags = [];
      this.getScenarios();
    },

    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.scenariosCount / this.pageSize);
    },

    updateSearchTerm() {
      this.searchTerm = document.getElementById("scenarioSeachTerm").value;
      this.searchTerm = this.searchTerm
        .toLowerCase()
        .replace(/[^a-zA-Z0-9-_' ']/g, "");
      this.searchTerm = this.searchTerm.split(/[ ,]+/).join(",");
      this.getScenarios();
    },

    pageSizeUpdated() {
      this.page = Math.floor((this.page * this.previousSelectedPageSize) / this.pageSize);
      this.previousSelectedPageSize = this.pageSize;
      this.getScenarios(this.pageSize * (this.page - 1));
    },
  },

  beforeMount() {
    this.isLoading = true;
  },

  mounted() {
    this.isLoading = true;
    this.getScenarios(0);
  },
};
</script>

<style scoped>
.placeholder {
  min-height: 300px;
  z-index: 9;
  margin-bottom: 30px;
}

.results-count {
  color: #014a8f;
  font-size: 14px;
}

@media (min-width: 992px) {
  .scenario-scroll-page {
  }
}

.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #224b8c;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}
.dropdown-btn {
  background-color: #599ed8;
  border-color: #599ed8;
  color: white;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.75rem;
  padding-left: 10px;
  height: 38px;
  margin-right: 18px;
}

[v-cloak] {
  display: none !important;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@media (max-width: 575.98px) {
  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
    .pagination-wrapper {
      margin: 0px !important;
      padding: 0px !important;
      display: flex;
    }
    .pagination-wrapper ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>
